import React from 'react';
import { Check } from 'lucide-react';

interface PropertyCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const PropertyCheckbox: React.FC<PropertyCheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false
}) => {
  return (
    <div className="flex items-center gap-2 py-1">
      <label className="text-gray-700 dark:text-gray-300 text-sm font-medium flex-1">
        {label}
      </label>
      <button
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`w-6 h-6 rounded flex items-center justify-center transition-colors ${
          checked 
            ? 'bg-primary-500 hover:bg-primary-600' 
            : 'bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-700 border border-gray-300 dark:border-gray-600'
        } ${disabled ? 'opacity-50' : 'cursor-pointer'}`}
      >
        {checked && <Check className="w-4 h-4 text-white" />}
      </button>
    </div>
  );
};

